import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import "../styles.css";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

function Contact({ contactJSON, onChange = () => {} }) {
  return (
    <div>
      <div className="container-fluid _createconcard ">
        <div className="row _createcontact ">
          <div className="col-6">
            <TextField
              label="Name"
              id="outlined-size-normal"
              defaultValue=""
              size="small"
              fullWidth
              value={contactJSON[0]?.ContactName}
              onChange={(e) => {
                onChange(e.target.value, "ContactName", "Cont");
              }}
            />
          </div>
          <div className="col-6">
            <TextField
              label=" Email"
              id="outlined-size-normal"
              defaultValue=""
              size="small"
              fullWidth
              value={contactJSON[0]?.Email}
              onChange={(e) => {
                onChange(e.target.value, "Email", "Cont");
              }}
            />
          </div>
        </div>
        {/* ------------------ */}
        <div className="row _createcontact ">
          <div className="col-6">
            <TextField
              label="Job Title"
              id="outlined-size-normal"
              defaultValue=""
              size="small"
              fullWidth
              value={contactJSON[0]?.jobTitle}
              onChange={(e) => {
                onChange(e.target.value, "jobTitle", "Cont");
              }}
            />
          </div>
          <div className="col-6">
            <TextField
              label=" Designation"
              id="outlined-size-normal"
              defaultValue=""
              size="small"
              fullWidth
              value={contactJSON[0]?.Designation}
              onChange={(e) => {
                onChange(e.target.value, "Designation", "Cont");
              }}
            />
          </div>
        </div>
        {/* ------------------ */}
        <div className="row _createcontact ">
          <div className="col-12">
            <FormGroup>
              <FormControlLabel
                control={<Switch defaultChecked />}
                label="Web Access Enable"
                value={contactJSON[0]?.IsWebEnable}
                onChange={(e) => {
                  onChange(e.target.value, "IsWebEnable", "Cont");
                }}
              />
            </FormGroup>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
